<template>
  <div>
    <!-- Edit -->
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      v-model="visible"
      :title="`Add / Update marks for ${subjectData ? subjectData.subject.name : ''} (${subjectData ? subjectData.subject.abbreviation : ''})`"
      onOk="handleOk"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update Mark</a-button>
      </template>
      <a-spin :spinning="spinning">
        <p class="text-muted mb-4">Enter the marks corresponding to the roll nos.</p>
        <a-form class="mb-4" :form="form">
          <div class="row neo-exam-mark-form-table-container" v-if="examData">
            <div class="col-12 col-md-12 col-lg-12">
              <table class="table table-bordered w-100">
                <thead>
                  <th style="width: 6%;">Sl. No.</th>
                  <th style="width: 10%;">Stud. Code</th>
                  <th style="width: 7%;">Roll No.</th>
                  <th style="width: 30%;">Name</th>
                  <th style="width: 10%;">Theory</th>
                  <th style="width: 10%;">Practical</th>
                  <th style="width: 10%;">Total</th>
                </thead>
                <tbody>
                  <tr v-for="(student_enrollment,index) in examData.students " :key="student_enrollment.id">

                      <a-form-item class="d-none">
                        <a-input
                          v-decorator="[`enroll_mark[${student_enrollment.id}][enrollment_id]`, { initialValue: student_enrollment.id }]"
                        />
                      </a-form-item>
                    <td>{{ index + 1 }}</td>
                    <td>{{ student_enrollment.student_code }}</td>
                    <td>{{ student_enrollment.roll_no }}</td>
                    <td>{{ student_enrollment.student.first_name }} {{ student_enrollment.student.last_name }}</td>
                    <td><a-form-item class="m-0">
                        <a-input
                          v-if="subjectData.grades_only === 1"
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][theory_grade]`, {rules: [{ required: false }] }]"
                          :disabled="false"
                          style="width: 100%;"
                          @change="handleTheoryScoreChange($event, student_enrollment.id)"
                        />
                        <a-input-number
                          v-else
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][theory_mark]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="false"
                          style="width: 100%;"
                          @change="handleTheoryScoreChange($event, student_enrollment.id)"
                        />

                    </a-form-item></td>
                    <td>
                      <a-form-item class="m-0">
                          <a-input
                            v-if="subjectData.grades_only"
                            placeholder=""
                            v-decorator="[`enroll_mark[${student_enrollment.id}][practical_grade]`, {rules: [{ required: false }] }]"
                            :disabled="true"
                            style="width: 100%;"
                            @change="handlePracticalScoreChange($event, student_enrollment.id)"
                          />
                          <a-input-number
                            v-else
                            placeholder=""
                            v-decorator="[`enroll_mark[${student_enrollment.id}][practical_mark]`, {rules: [{ required: false }] }]"
                            :min="0"
                            :disabled="false"
                            style="width: 100%;"
                            @change="handlePracticalScoreChange($event, student_enrollment.id)"
                          />
                    </a-form-item></td>
                    <td><a-form-item class="m-0">
                        <a-input
                          v-if="subjectData.grades_only"
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][grade]`, {rules: [{ required: false }] }]"
                          :disabled="true"
                          style="width: 100%;"
                        />
                        <a-input-number
                          v-else
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][mark]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="true"
                          style="width: 100%;"
                        />
                    </a-form-item></td>
                  </tr>
                </tbody>
              </table>
            </div>

<!--            <div class="col-6 col-md-4 col-lg-3" v-for="student_enrollment in examData.students" :key="student_enrollment.id">
              <table class="table table-bordered table-sm-responsive">
                <thead>
                  <th>Roll No.</th>
                  <th>Name</th>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" style="min-width:45px;">
                      {{ student_enrollment.student.first_name }}
                    </th>
                    <th scope="row" style="min-width:45px;">
                      {{ student_enrollment.roll_no }}
                    </th>
                    <td>
                      <a-form-item class="d-none">
                        <a-input
                          v-decorator="[`enroll_mark[${student_enrollment.id}][enrollment_id]`, { initialValue: student_enrollment.id }]"
                        />
                      </a-form-item>
                      <a-form-item class="m-0">
                        <a-input-number
                          placeholder=""
                          v-decorator="[`enroll_mark[${student_enrollment.id}][exam_mark_score]`, {rules: [{ required: false }] }]"
                          :min="0"
                          :disabled="false"
                          style="width: 100%;"
                        />
                      </a-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>-->
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { makeFieldsData } from '../fields'
import { mapState } from 'vuex'
// import {mapValues} from "lodash";

export default {
  name: 'ClassExamMarksForm',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      subjectData: null,
      examData: null,
      studentsData: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openClassExamMarksForm', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
    examSubjects: function () {
      return this.examData.class_section_exam_subject
    },
  },
  methods: {
    showModal: function(subject, exam, studentsData) {
      this.visible = true
      this.subjectData = subject
      this.examData = exam
      this.studentsData = studentsData
      this.$nextTick(() => {
        const fieldsData = makeFieldsData(studentsData)
        this.form.setFieldsValue(fieldsData)
      })
    },
    handleTheoryScoreChange (theoryValue, enrollmentId) {
      const fieldData = {}
      if (this.subjectData.grades_only) { // If grade
        fieldData[`enroll_mark[${enrollmentId}][grade]`] = theoryValue.target.value // for a-input it receives as Event
      } else { // If not grade
        let practicalFieldValue = this.form.getFieldValue(`enroll_mark[${enrollmentId}][practical_mark]`)
        let totalMark = theoryValue + practicalFieldValue
        totalMark = (theoryValue == null && practicalFieldValue == null ? null : totalMark)
        if (practicalFieldValue == null) {
          totalMark = theoryValue
        }
        fieldData[`enroll_mark[${enrollmentId}][mark]`] = totalMark
      }
      this.form.setFieldsValue(fieldData)
    },
    handlePracticalScoreChange: function (practicalValue, enrollmentId) {
      const fieldData = {}
      if (this.subjectData.grades_only) { // If grade dont do anything for practical
        // fieldData[`enroll_mark[${enrollmentId}][grade]`] = practicalValue.target.value // for a-input it receives as Event
      } else { // If not grade
        let theoryFieldValue = this.form.getFieldValue(`enroll_mark[${enrollmentId}][theory_mark]`)
        let totalMark = practicalValue + theoryFieldValue
        totalMark = (practicalValue == null && theoryFieldValue == null ? null : totalMark)
        if (theoryFieldValue == null) {
          totalMark = practicalValue
        }
        fieldData[`enroll_mark[${enrollmentId}][mark]`] = totalMark
      }
      this.form.setFieldsValue(fieldData)
    },
    handleSubmit: function (e) {
      // this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              // values.class_section_exam_id = this.examData.id
              // values.subject_id = this.subjectData.id
              let formData = {}

              console.log(this.studentsData)
              formData.class_section_exam_id = this.examData.id
              formData.subject_id = this.subjectData.subject.id
              let studentDataTemporaryMap = null
              if (this.subjectData.grades_only === 1) {
                studentDataTemporaryMap = new Map(this.studentsData.map(item => [item.id, item.student_exam_mark[0] ? item.student_exam_mark[0].grade : null]))
              } else {
                studentDataTemporaryMap = new Map(this.studentsData.map(item => [item.id, item.student_exam_mark[0] ? item.student_exam_mark[0].mark : null]))
              }
              formData.enroll_mark = values.enroll_mark.flat().filter(element => {
                if (element) {
                  const originalMark = studentDataTemporaryMap.get(element.enrollment_id)
                  return originalMark !== undefined && element.mark !== originalMark // To filter only modified mark students
                } else {
                  return false
                }
              }).map(el => {
                if (!el.hasOwnProperty('exam_score')) {
                  el.exam_score = null
                }
                // if (el.exam_mark_score === null) {
                //   el.exam_mark_score = null
                // }

                return el
              })

              this.$http
                .post('/api/studentexammark', formData)
                .then(() => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: 'Subject marks updated successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
